import { displayFilesize } from '../helpers/displayFilesize';
import { GridValueFormatterParams } from '@mui/x-data-grid';

export const FilesizeFormatter = ({ value }: GridValueFormatterParams): string =>
  typeof value === 'number' ? displayFilesize(value) : '';
